import React from 'react';
import { Button, Divider, makeStyles } from '@material-ui/core';
import { trackServiceSelect } from 'shared/helper/tracker';
import { getServiceName, launch } from 'shared/helper/serviceLauncher';
import configuration from 'envConfig';
import { formatarNit } from 'shared/helper/formatadores';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
    },  
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',     
    },
  },
  dataContainer: {
    display: 'flex',
    flexDirection: 'rown',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  dataTitle: {
    color: theme.shared.template.InfoScreen.primaryText.color,
    fontWeight: '600',
    fontSize: '1.2em',
  },
  dataCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px',
    borderRadius: '10px',
    
    boxShadow: '0px 3px 6px #00000029',
    backgroundColor: theme.shared.template.InfoScreen.card.backgroundColor,
    opacity: '1',
    width: '100%',
    height: 'auto',
    padding: '16px 0',    
  },
  dataCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    width: '100%',
    minHeight: '112px',
  },
  dataCardContainerGeral:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    width: '100%',
    minHeight: '112px',    
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  dataCardContainerHr: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '10px',    
  },
  dataCardTitle: {
    fontSize: '1.2em',
    fontWeight: '600',
    padding: '0 64px'
  },
  dataCardLabelBold: {
    fontSize: '1.2em',
    color: theme.shared.template.InfoScreen.primaryText.color,
    fontWeight: '600',
    marginBottom: '8px',    
  },
  dataCardContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    width: '100%',
  },
  dataCardInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',    
    padding: '16px 64px',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'unset',      
    },
  },
  dataCardLabel: {
    fontSize: '1.1em',
    color: theme.shared.template.InfoScreen.secondaryText.color,
    fontWeight: '600 !important',
    paddingRight: '5px',
  },
  dataCardText: {
    fontSize: '1.1em',
    color: theme.shared.template.InfoScreen.secondaryText.color,
    fontWeight: 'normal !important',
    marginBottom: '14px',
  },
  span: {    
    backgroundColor: 'green',
    color: 'white',
    padding: '8px',
    width: 'fit-content'
  },
  nit: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',     
  },
  conteudo: {    
    padding: '16px 64px',
    backgroundColor: theme.palette.mode == 'dark' ? '#33333' : '#F8F8F8',
    width: '100%'
  }
}));

const DadosDaInscricaoINSS = (props) => {
  const { data, dados } = props;
  const classes = useStyles();

  return (
    dados.nitPrevalente && 
      <div className={classes.container}>
        <div className={classes.dataContainer}>      
          <div className={classes.dataCard}>
            <div className={classes.dataCardContainerGeral}>
              <div className={classes.dataCardContainer} >
                    <div className={`${classes.dataCardLabelBold} ${classes.dataCardTitle}`}>
                      <span>Dados do INSS</span>
                    </div>
                {data && 
                <div className={classes.conteudo}>
                  <div className={classes.dataCardLabelBold}>
                    <span>Nome Completo</span>
                  </div>
                  <div className={classes.dataCardText}>
                    <span>{dados.nome}</span>
                  </div>
                  <div className={classes.dataCardLabelBold}>
                    <span>Data de Nascimento</span>
                  </div>
                  <div className={classes.dataCardText}>
                    <span>{dados.dataNascimento}</span>
                  </div>
                  <div className={classes.dataCardLabelBold}>
                    <span>Nome da Mãe</span>
                  </div>
                  <div className={classes.dataCardText}>
                    <span>{dados.nomeMae}</span>
                  </div>
                </div>
                }
                <div className={classes.dataCardInfo}>                
                  <span className={classes.span}>ativo</span>                
                  
                  <div className={classes.nit}>
                    <span>Número de Identificação do Trabalhador (NIT)</span>
                    <span>{formatarNit(dados.nitPrevalente)}</span>
                  </div>
                  
                </div>
                
              </div>
            </div>
          </div>
        </div>
        
      </div>
  );
};

export default DadosDaInscricaoINSS;
